import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Index from "../views/Index.vue";
import Index2 from "../views/index2.vue";
import CourseDetail from "../views/EnterCenter/components/CourseDetail.vue";
import CourseReport from "../views/StudyReport/components/CourseReport.vue";
import MemberInfo from "../views/StudyReport/components/MemberInfo.vue";
import MyRights from "../views/MyRights/Index.vue";
import StudyPlan from "../views/StudyPlan/Index.vue";
import MakePlan from "../views/MakePlan/Index.vue";
import OtherPlan from "../views/StudyPlan/components/OtherPlan.vue";
import EchartsReport from "../views/StudyPlan/components/EchartsReport.vue";
import ExerciseTest from "../views/StudyPlan/components/ExerciseTest.vue";
import InstantTest from "../views/StudyPlan/components/InstantTest.vue";
import PlanDetail from "../views/StudyPlan/components/PlanDetail.vue";
import ExerciseScore from "../views/StudyPlan/components/ExerciseScore.vue";
import OfflineCourseDetail from "../views/MyRights/components/CourseDetail.vue";
import OfflineCourseRules from "../views/MyRights/components/CourseRules.vue";
import Establishment from "../views/Establishment/index.vue";
import Questing from "../views/Questing/index.vue";
import LineQuesting from "../views/Questing/components/LineQuesting.vue";
import TelQuesting from "../views/Questing/components/TelQuesting.vue";
import CourseForm from '../views/CourseManage/CourseForm.vue'

import jyml from '../views/jyml/index.vue';
import ztDetails from '../views/ztDetails';
import xxbg from '../views/xxbg';
// 考试相关路由
import exam from '../views/exam/index.vue'
import apper from '../views/exam/apper.vue'
import result from '../views/exam/result.vue'
import report from '../views/exam/report.vue'

import Management_evaluation from '../views/Management_evaluation/index.vue';
import statistics from '../views/statistics/index.vue';

//企业报告
import CompanyReport from '../views/companyReport/index.vue'
import { userCompanyInfo, checkDeptExpire } from '@/api/index.js';


//企业会员
import qyhy from '../views/qyhy/index.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: "/CourseForm",
    name: "CourseForm",
    component: CourseForm,
  },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  // path: "/index/:id/:dept/:token",
  {
    path: "/index",
    name: "Index",
    component: Index2,
  },
  {
    path: "/qyhy",
    name: "qyhy",
    component: qyhy,
  },
  // {
  //   path: "/index2/:id/:dept/:token",
  //   name: "Index2",
  //   component: Index2,
  // },
  {
    path: "/courseDetail/:mode/:id/:dept/:video",
    name: "CourseDetail",
    component: CourseDetail,
  }, {
    path: '/ztDetails/:id',
    name: "ztDetails",
    component: ztDetails
  },
  {
    path: '/xxbg/:id',
    name: "xxbg",
    component: xxbg
  },
  {
    path: '/Management_evaluation/:id/:name',
    name: "Management_evaluation",
    component: Management_evaluation
  },
  {
    path: '/statistics/:id/:name',
    name: "statistics",
    component: statistics
  },
  {
    path: '/companyReport/:year',
    name: "CompanyReport",
    component: CompanyReport
  },
  {
    path: "/courseReport/:id/:dept",
    name: "CourseReport",
    component: CourseReport,
  },
  {
    path: "/memberInfo/:mode/:id/:userDept/:dept",
    name: "MemberInfo",
    component: MemberInfo,
  },
  {
    path: "/myRights/:mode",
    name: "MyRights",
    component: MyRights,
  },
  {
    path: "/studyPlan/:mode",
    name: "StudyPlan",
    component: StudyPlan,
  },
  {
    path: "/managePlan/otherPlan",
    name: "OtherPlan",
    component: OtherPlan,
  }, {
    path: '/jyml/:id',
    name: 'jyml',
    component: jyml
  },
  {
    path: "/makePlan",
    name: "MakePlan",
    component: MakePlan,
  },
  {
    path: "/echartsReport/:id",
    name: "EchartsReport",
    component: EchartsReport,
  },
  {
    path: "/exercise/:planId/:examId",
    name: "ExerciseTest",
    component: ExerciseTest,
  },
  {
    path: "/instantTest/:contentsId",
    name: "InstantTest",
    component: InstantTest,
  },
  {
    path: "/planDetail/:mode/:id",
    name: "PlanDetail",
    component: PlanDetail,
  },
  {
    path: "/exerciseScore",
    name: "ExerciseScore",
    component: ExerciseScore,
  },
  {
    path: "/myRights/offline-course/detail",
    name: "OfflineCourseDetail",
    component: OfflineCourseDetail,
  },
  {
    path: "/myRights/offline-course/rules",
    name: "OfflineCourseRules",
    component: OfflineCourseRules,
  },
  {
    path: "/establishment",
    name: "Establishment",
    component: Establishment,
  },
  {
    path: "/questing",
    name: "Questing",
    component: Questing,
    redirect: "/questing/line",
    children: [
      {
        path: "line",
        name: "linequesting",
        component: LineQuesting,
      },
      {
        path: "tel",
        name: "telquesting",
        component: TelQuesting,
      },
    ],
  },
  {
    path: '/exam/:id',
    name: 'exam',
    component: exam,
  },
  {
    path: '/apper',
    name: 'apper',
    component: apper,
  },
  {
    path: '/result',
    name: 'result',
    component: result,
  },
  {
    path: '/report',
    name: 'report',
    component: report,
  },

];

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
});




//路由守卫
router.beforeEach(async (to, from, next) => {
  const { token, deptId } = to.query;

  if (!token || !deptId) return next();
  localStorage.clear();
  localStorage.setItem('token', token.replace(/^"|"$/g, ''));
  localStorage.setItem('dept', deptId);
  //checkLoginRecord();
  // userCompanyInfo({}, { Authorization: token }).then(res => {
  //   if (res.code == 200) {
  //     localStorage.setItem('token', token.replace(/^"|"$/g, ''));
  //     localStorage.setItem('dept', deptId);
  //     localStorage.setItem('TopDeptId', res.data.topDeptId);
  //     debugger;
  //   }
  // })
  router.push('/index');
  next(false);



})



export default router;
